import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(app)/dashboard/components/DashboardContent.tsx");
